export default __webpack_public_path__ + "static/media/shareIcon-copy.8483daf4.svg";